import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDrawer, MatDrawerContainer } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { AuthService } from '@journal/app/core/api/auth/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { User } from '@sparro/app/core/models/user.model';
import { UserService } from '@sparro/core/api/user/user.service';
import { JournalService } from '@journal/app/core/api/journal/journal.service';
import { environment } from '@journal/env/environment';
import { SearchService } from '@sparro/core/api/search/search.service';

export class SEOContent {
  title: string;
  content: string;
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'journal';
  seoContent: SEOContent;
  user: User;
  path: string;


  @ViewChild('leftnav') leftnav: MatDrawer;
  @ViewChild('rightnav') rightnav: MatDrawer;
  @ViewChild('matDrawerContainer') matDrawerContainer: MatDrawerContainer;

  constructor(
    private userService: UserService,
    private searchService: SearchService,
    private journalService: JournalService,
    private authService: AuthService,
    private cookieService: CookieService,
    private router: Router
  ) {
    this.router.events.subscribe(
      () => this.path = this.router.url
    );
    this.path = this.router.url;
  }

  ngOnInit(): void {
    this.searchService.setActiveAppFeedUrl(`${environment.postUrl}`);
    this.userService.fetchUser((user) => this.user = user);
    this.getSeoContent();
  }

  getSeoContent() {
    this.journalService.getSeoContent().subscribe(
      (response: SEOContent) => {
        this.seoContent = response;
      }
    )
  }

  closeBackdrop(): void {
    this.matDrawerContainer.hasBackdrop = false;
  }

  rightToggle(event): void {
      this.matDrawerContainer.hasBackdrop = true;
      this.rightnav.toggle();
  }

  goToSearchPage(searchText: (string | void)): void {
    if (searchText) {
      this.router.navigate(['search'], {
        queryParams: {
          query: searchText,
        },
      });
    }
    else {
      this.router.navigate(['search']);
    }
  }

  showFooter(): boolean {
    if (this.router.url.includes('edit')) {
      return false;
    }
    return true;
  }

  logout(toLogout): void {
    this.authService.logout().subscribe(
      (response) => {
        this.cookieService.deleteAll('/', '.uni.xyz');
        this.userService.unsetUser();
        window.location.href = `${environment.postUrl}`;
      },
      (error) => {
        console.log(error);
      });
  }

}
